<template lang='pug'>
    div(
        v-if="stockId !== 0"
        @click="onClick()"
        class="main-ticker-container"
        /*:style="`width:${width}px; height:${height}px; line-height:${lineHeight};`"*/
        :title="getTicker(stockId)"
    ) {{ getTicker(stockId) }}

    div(
        v-else-if="stockId === 0"
        @click="clickTicker(getTickerName)"
        class="main-ticker-container"
        /*:style="`width:${width}px; height:${height}px; line-height:${lineHeight};`"*/
        :title="getTickerName"
    ) {{ getTickerName }}
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';

export default Vue.extend({
    name: 'Ticker',
    props: {
        isClickable: {
            type: Boolean,
            default: true
        },
        stockId: {
            type: Number,
            default: 0
        },
        width: {
            type: Number,
            default: 60
        },
        height: {
            type: Number,
            default: 19
        },
        lineHeight: {
            type: Number,
            default: 1.8
        }
    },
    computed: {
        ...mapGetters([
            'getMapStocks'
        ]),
        getTickerName() {
            if(this.stockId === 0) {
                return this.getMapStocks.find((s) => s.ticker === this.params.value).ticker;
            }

            return '';
        }
    },
    methods: {
        onClick() {
            if(this.isClickable) {
                this.$router.push({ name: 'landing-page.stock-detail', params: { stock_id: this.stockId } });
            }
        },
        getTicker(stock_id) {
            const s = this.getMapStocks.find(s => s.stock_id == stock_id);
            if (!s) {
                return null;
            }

            return s.ticker;
        },
        clickTicker(ticker) {
            if(this.stockId === 0) {
                this.params.action(ticker);
            }
        }
    }
});
</script>

<style scoped>

.main-ticker-container {
    cursor: pointer;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    color: #144B4D;
    background-color: #EDBC9B;
    font-size: 11px;
    font-weight: 600;
    border-radius: 3px;
    padding-left: 6px;
    padding-right: 6px;
    text-align: center;
    width: 60px;
    height: 18px;
    line-height: 19px;
}

</style>
